<section mhFilterBar>
  <div mhFilterGroup>
    <div>
      <mh-core-lib-datepicker [currentDates]="currentDates" [currentFilter]="currentFilterDate"
        (datepickerUpdated)="handleDatepickerUpdated($event)">
      </mh-core-lib-datepicker>
    </div>
    <mh-index-selector [translationPrefix]="prefixTranslateFilters"
      (optionSelected)="setSelectlValue($event)" [actions]="actions" [optionsWithTag]="optionsWithTag" [selectedOption]="currentTrend?.value"></mh-index-selector>
    <ng-container *ngIf="trendSelected === 'ranking_areas' && areas.length > 0 && areasList">
      <mh-index-selector [translationPrefix]="'areas'" [actions]="areasList" [selectedOption]="areaSelected"
        [valueType]="'number'" (optionSelected)="setAreaValue($event, 'areas')">
      </mh-index-selector>
    </ng-container>
    <mh-box-element *ngIf="fidelityPermisions.includes('interchain_followup_trends_result')">
      <mh-core-lib-filter-chain-zone [productId]="productId" [multipleSelectionMode]="true" (chainChanged)="setChain($event)"
        [disabled]="!isReady"></mh-core-lib-filter-chain-zone>
    </mh-box-element>
    <mh-core-lib-filter-hotels [chainFilter]="originalChainFilter" [multipleSelectionMode]="true" (hotelsChanged)="setHotelsFilter($event)"
      [disabled]="!isReady"></mh-core-lib-filter-hotels>  
    <mh-core-lib-survey-wrapper *ngIf="chainFilter.length > 0 && isReady" [productId]="productId" [chain]="chainFilter" [listenCustomerSubscribe]="false" [multipleSelectionMode]="true"
      (currentSurveySetted)="onSurveysLoaded($event)"
      #surveyWrapper></mh-core-lib-survey-wrapper>  
  </div>

  <div>
    <mh-filter-date [startDate]="startDate" [endDate]="endDate" [type]="'trends'" [persistDate]="false"
      [report]="fidelityPermisions.includes('interchain_followup_trends_report') ? report : null "
      [reportActiveEmail]="true" [checkPermissions]="true" [slug]="reportSlug"></mh-filter-date>
  </div>
</section>

<ng-container *ngIf="chainFilter.length > 0 && surveysReady && isReady">
  <mh-core-lib-generic-box customClass="tw-border tw-border-gray-200 !tw-shadow-md tw-p-5 tw-w-full"
    *ngIf="fidelityPermisions.includes('interchain_followup_trends_result')">
    <div class="content-wrapper">
      <mh-inter-chain-trends *ngIf="surveysReady" [actions]="actions" [currentDates]="currentDates" [showFilters]="showFilters" [chain]="chainFilter"
        [showAreas]="showAreas" [areaSelected]="areaSelected" [currentTrend]="currentTrend" [trend]="currentTrend.value"
        (areaChange)="setAreaValue($event, 'areas')" (isReady)="dataIsReady($event)" [productId]="productId">
      </mh-inter-chain-trends>
    </div>
  </mh-core-lib-generic-box>
</ng-container>